import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CONSERVATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('description', 'Entity.ConservationType.Description')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ConservationType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const CONSERVATIONTYPE_CONFIG = {
  entityName: 'ConservationType',
  localizationKey: 'Planning::Entity.ConservationType',
  fields: CONSERVATIONTYPE_FIELDS,
  permission: 'PlanningEnvironment.ConservationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
